import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import ChannelCard from "../Atomics/ChannelCard/ChannelCard";
import LogoutModal from "../Navigation/LogoutModal";
import { channelFetcher } from "../../api/requests";
import { ProfileContext } from "../../context/profile";
import { useContext, useState, useEffect } from "react";
import { SelectedChannelsProvider } from "../../context/selectedChannels";

export default function AdminChannels({
  mine,
  userChannels: initialUserChannels,
  header,
  admin,
}) {
  const [userChannels, setUserChannels] = useState(initialUserChannels || []);
  const [showDel, setShowDel] = useState(false);
  const [id, setId] = useState(null);

  useEffect(() => {
    setUserChannels(initialUserChannels || []);
  }, [initialUserChannels]);

  const handleDeleteItem = (id) => {
    setShowDel(true);
    setId(id);
  };

  const handleClose = () => {
    setShowDel(false);
  };

  const handleDelete = async () => {
    try {
      await channelFetcher.delete(id);
      setUserChannels((prevChannels) =>
        prevChannels.filter((channel) => channel.id !== id)
      );
      setShowDel(false);
    } catch (error) {
      console.error("Error deleting channel:", error);
    }
  };

  return (
    <>
      <div
        className="video-block section-padding"
        style={{
          // maxWidth: "1500px",
          paddingLeft: "30px",
          paddingRight: "30px",
        }}
      >
        <Row>
          <Col md={12}>
            <SectionHeader
              more={{
                status: userChannels?.length > 4,
                value: "/myChannels/",
                state: { admin: true },
              }}
              heading={header}
            />
          </Col>

          {userChannels?.length > 0 ? (
            userChannels.slice(0, 4).map((item, index) => (
              <Col xl={3} sm={6} className="mb-3" key={index}>
                <ChannelCard
                  total_video_count={item?.total_video_count}
                  imgSrc={item?.channel?.avatar}
                  views={item?.channel?.counted_view || 0}
                  videoViews={item?.channel?.total_video_views || 0}
                  channelName={item?.channel?.name}
                  subscriberCount={item?.channel?.subscribe_count || 0}
                  mine={mine}
                  admin={admin}
                  videosId={item?.channel?.name}
                  imgHref={`/single-channel/${item?.channel?.id}`}
                  channelHref={`/single-channel/${item?.channel?.id}`}
                  channelId={item?.channel?.id}
                  onDelete={() => handleDeleteItem(item?.channel?.id)}
                  moreAdress={`/myVideos/${item?.channel?.id}`}
                />
              </Col>
            ))
          ) : (
            <p className="mr-3">کانالی وجود ندارد.</p>
          )}
        </Row>
      </div>

      {showDel && (
        <LogoutModal
          show={showDel}
          type="delete"
          name="کانال"
          handleClose={handleClose}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
}
